import { DirectionCardModel } from './Cards/DirectionCardModel'
import { ProfessionModel } from './Cards/FutureProfItemModel'
import { BaseModel } from '~/shared/model'

/* eslint-disable camelcase */

export class BookCategoryModel extends BaseModel {
  created_at: string = ''
  id: number = 0
  title: string = ''
  updated_at: string = ''
}

export class BookCardModel extends BaseModel {
  id: string = ''
  author?: string = ''
  name?: string = ''
  image?: string = ''
  slug? = ''
}

export class BookModel extends BaseModel {
  author: string = ''
  category: BookCategoryModel | null = null
  category_id: number = 0
  created_at: string = ''
  description: string = ''
  id: number = 0
  image: string = ''
  industry: DirectionCardModel[] = []
  is_published: number = 0
  link: string = ''
  name: string = ''
  price: string = ''
  profession: ProfessionModel[] = []
  slug: string = ''
  special_price: string = ''
  updated_at: string = ''
}
